import { useEffect } from 'react';

const useCardStyles = () => {
  useEffect(() => {
    const injectStyle = (el, css) => {
      if (!el.shadowRoot) return;

      if (el.shadowRoot.querySelector('style[data-injected="true"]')) return;

      const style = document.createElement('style');
      style.setAttribute('data-injected', 'true');
      style.textContent = css;
      el.shadowRoot.appendChild(style);
    };

    const applyStyles = () => {
      const cards = document.querySelectorAll('.carousel-ads-card');
      cards.forEach((card) => {
        injectStyle(card, '.c-card__wrapper { overflow: visible !important; }');
      });

      const cardsContent = document.querySelectorAll('.c-image-above-text-card__content');
      cardsContent.forEach((card) => {
        injectStyle(card, '.c-card-content { overflow: visible !important; }');
      });
    };

    applyStyles();

    const observer = new MutationObserver(() => applyStyles());
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
};

export default useCardStyles;
